// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zkaC","col":"styles_col__3sDmZ"};